import jwt from 'jwt-decode';

export const decodeJwt = (token: string): JWTokenPayload => {
  const payload = jwt(token)
  return payload as JWTokenPayload
}

export interface JWTokenPayload {
  role: string
  serviceId: number
  userId: number
  alias: string
  user: string
  service: {
    serviceId: number
    service: string
    countryId: number
    country: string
    dateCreated: string
    mandatoryField: string
  }
}
